import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/store';
import Home from '@/views/Home.vue';
import Dashboard from '@/views/Dashboard.vue';
import Admin from '@/features/admin/components/index.vue';
import Login from '@/features/account/components/Login.vue';
import Register from '@/features/account/components/Register.vue';
import ManageUser from '@/features/account/components/ManageUser.vue';
import EmailConfirmation from '@/features/account/components/EmailConfirmation.vue';
import EmailConfirmationRequest from '@/features/account/components/EmailConfirmationRequest.vue';
import ResetConfirmation from '@/features/account/components/ResetConfirmation.vue';
import ResetPassword from '@/features/account/components/ResetPassword.vue';
import ResetPasswordRequest from '@/features/account/components/ResetPasswordRequest.vue';
import SalesReceipt from '@/features/salesreceipts/components/SalesReceipt.vue';

Vue.use(Router);

const ifAuthenticated = (to: any, from: any, next: any) => {
  if (store.getters['auth/isAuthenticated']) {
    next();
    return;
  }
  next('/login');
};

const ifAdmin = (to: any, from: any, next: any) => {
  if (store.getters['auth/isAuthenticated'] && store.getters['auth/isAdmin']) {
    next();
    return;
  }
  next('/login');
};

const ifNotAuthenticated = (to: any, from: any, next: any) => {
  if (!store.getters['auth/isAuthenticated']) {
    next();
    return;
  }
  next('/');
};

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/confirm/:userId',
      name: 'emailConfirmationRequest',
      component: EmailConfirmationRequest,
      props: true,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/confirm/email',
      name: 'emailConfirmation',
      component: EmailConfirmation,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/manage',
      name: 'manageUser',
      component: ManageUser,
    },
    {
      path: '/forgot',
      name: 'resetPasswordRequest',
      component: ResetPasswordRequest,
    },
    {
      path: '/forgot/password',
      name: 'resetPassword',
      component: ResetPassword,
    },
    {
      path: '/reset/success',
      name: 'resetConfirmation',
      component: ResetConfirmation,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      beforeEnter: ifAdmin,
    },
    {
      path: '/salesreceipts',
      name: 'salesReceipts',
      component: SalesReceipt,
      beforeEnter: ifAuthenticated,
    },
  ],
});

export default router;
